/**
 * F-131 — the lifecycle bands on the 0–1000 scale (display only).
 *
 * The score is computed on the server (hermes `_shared/prometheus/roadmap-score.ts`); the
 * stored stage code is labelled here so a label change never waits for a recompute. The bands
 * are the app's existing 0–100 stages ×10 (Tim, 8 Sep 2026); Prime stays at 850.
 */

export interface LifecycleBand {
  code: string;
  label: string;
  min: number;
  max: number;
}

export const LIFECYCLE_BANDS: LifecycleBand[] = [
  { code: 'birth', label: 'Birth', min: 0, max: 99 },
  { code: 'startup', label: 'Startup', min: 100, max: 199 },
  { code: 'early-stage', label: 'Early Stage', min: 200, max: 399 },
  { code: 'buildup', label: 'Buildup', min: 400, max: 599 },
  { code: 'scale-up', label: 'Scale-up', min: 600, max: 699 },
  { code: 'systemise', label: 'Systemise', min: 700, max: 849 },
  { code: 'prime', label: 'Prime', min: 850, max: 1000 },
];


// The declared (non-score) stages the 0–100 scale also knows; never produced by the bands
// above, but a stored stage code may carry one.
const LIFECYCLE_VARIANT_LABELS: Record<string, string> = {
  stagnation: 'Stagnation',
  decline: 'Decline',
  reinvention: 'Reinvention',
  // Legacy: snapshots frozen before the bands were aligned with the 0–100 stages.
  death: 'Death',
};

/** The label for a stored stage code (a snapshot's `lifecycle_stage`); unknown codes pass through. */
export function lifecycleLabelFor(code: string): string {
  return LIFECYCLE_BANDS.find((b) => b.code === code)?.label ?? LIFECYCLE_VARIANT_LABELS[code] ?? code;
}
